import { render, staticRenderFns } from "./openUnApproveProviderFree.vue?vue&type=template&id=212488f2&scoped=true&"
import script from "./openUnApproveProviderFree.vue?vue&type=script&lang=ts&"
export * from "./openUnApproveProviderFree.vue?vue&type=script&lang=ts&"
import style0 from "./openUnApproveProviderFree.vue?vue&type=style&index=0&id=212488f2&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "212488f2",
  null
  
)

export default component.exports